var Bavaria = "Bavière";
var Berlin = "Berlin";
var Brandenburg = "Brandebourg";
var Bremen = "Brême";
var Hamburg = "Hambourg";
var Hesse = "Hesse";
var Saarland = "Sarre";
var Saxony = "Saxe";
var Thuringia = "Thuringe";
var DEStates = {
	"Baden-Wuerttemberg": "Bade-Wurtemberg",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Mecklembourg-Poméranie occidentale",
	"Lower Saxony": "Basse-Saxe",
	"North Rhine-Westphalia": "Rhénanie-du-Nord-Westphalie",
	"Rhineland-Palatinate": "Rhénanie-Palatinat",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Saxe-Anhalt",
	"Schleswig-Holstein": "Schleswig-Holstein",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
